export default __webpack_public_path__ + "static/553-8f4ecee6a39697efbb622a983996998f.gif";